import { createPlatePlugin } from 'platejs/react'
import type { AnyPlatePlugin } from 'platejs/react'

import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'
import { withSafeClipboard } from '~publish/legacy/editor/plugins/clipboard/withSafeClipboard'

export const SAFE_CLIPBOARD_PLUGIN_KEY = 'safe-clipboard'

// Not returned directly from the arrow function: an explicit return type on
// the expression itself back-propagates into createPlatePlugin's own
// generic inference and corrupts it (options/node end up typed against the
// annotation's defaults instead of the literal passed in).
export const createSafeClipboardPlugin = (): AnyPlatePlugin => {
  const plugin = createPlatePlugin({
    key: SAFE_CLIPBOARD_PLUGIN_KEY,
    extendEditor: ({ editor }) =>
      withSafeClipboard(editor as unknown as BufferEditor),
  })
  return plugin
}
